import { Badge, Group, Stack, Text } from "@mantine/core";
import StatusText from "../../../../common/components/DataTable/StatusText";
import { formatAmount, formatPolicyDate, purchaseMethodLabel } from "../../utils/allPolicyHelpers";
import classes from "./TripPolicyDrawer.module.css";

const TripDrawerHeader = ({ trip }) => {
  if (!trip) return null;
  const duration = trip.duration != null ? `${trip.duration} days` : "—";

  return (
    <div className={classes.header}>
      <Group justify="space-between" align="flex-start" wrap="wrap">
        <Stack gap={6} className={classes.headerMain}>
          <Text size="xs" c="rgba(255,255,255,0.8)">
            POLICY #{trip.id} · {trip.cover_type || "—"}
          </Text>
          <Text fw={700} size="lg" lh={1.3} style={{ wordBreak: "break-word" }}>
            {trip.cover_name || "—"}
          </Text>
          {trip.uuid ? (
            <Text size="xs" c="rgba(255,255,255,0.7)" style={{ wordBreak: "break-all" }}>
              {trip.uuid}
            </Text>
          ) : null}
          <Group gap={8} mt={4} wrap="wrap">
            <StatusText status={trip.status} field="status" />
            <Badge variant="light" color="gray">{purchaseMethodLabel(trip.purchase_method)}</Badge>
            <Badge variant="light" color="gray">{duration}</Badge>
          </Group>
        </Stack>
        <Stack gap={2} align="flex-end" className={classes.headerAmount}>
          <Text fw={700} size="xl">
            {formatAmount(trip.currency, trip.total_amount)}
          </Text>
          <Text size="sm" c="rgba(255,255,255,0.85)">
            {trip.no_of_pax ?? 0} pax
          </Text>
        </Stack>
      </Group>
      <div className={classes.contactBar}>
        <Text size="sm" className={classes.contactItem}>👤 {trip.user_name || "—"}</Text>
        <Text size="sm" className={classes.contactItem}>📞 {trip.phone_number || "—"}</Text>
        <Text size="sm" className={classes.contactItem}>✉ {trip.email || "—"}</Text>
        <Text size="xs" c="rgba(255,255,255,0.7)" className={classes.contactItem}>
          Created {formatPolicyDate(trip.created_on)}
        </Text>
      </div>
    </div>
  );
};

export default TripDrawerHeader;
